/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member-management', {
            parent: 'board',
            url: '/board/members?page&sort&search&select',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.memberManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/member-management/member-management.html',
                    controller: 'MemberManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'user.createdDate,desc',
                    squash: true
                },
                select: {
                    value: 'voll',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('member-management');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('member-management-detail', {
            parent: 'member-management',
            url: '/member/{id}',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.memberManagement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/member-management/member-management-detail.html',
                    controller: 'MemberManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('enumClothingSize');
                    $translatePartialLoader.addPart('enumGender');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    $translatePartialLoader.addPart('activities');
                    $translatePartialLoader.addPart('enumCategoryActivity');
                    $translatePartialLoader.addPart('enumIDType');
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MemberManagement', function($stateParams, MemberManagement) {
                    return MemberManagement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'member-management',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('member-management-detail.edit', {
            parent: 'member-management-detail',
            url: '/edit',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/member-management/member-management-dialog.html',
                    controller: 'MemberManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('member-management.edit', {
            parent: 'member-management',
            url: '/board/member/{id}/edit',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/member-management/member-management-edit-member-status.html',
                    controller: 'MemberManagementDialogEditMemberStatusController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        profile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member-management', null, { reload: 'member-management' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('member-management.mail', {
            parent: 'member-management',
            url: '/mail',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/member-management/member-management-send-mail.html',
                    controller: 'MemberManagementDialogSendMailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('member-management', null, { reload: 'member-management' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('member-management.delete', {
            parent: 'member-management-detail',
            url: '/delete',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/member-management/member-management-delete-dialog.html',
                    controller: 'MemberManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member-management', null, { reload: 'member-management' });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('member-management-detail.delete-certificate', {
            parent: 'member-management-detail',
            url: '/certificate/delete',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/member-management/member-management-delete-certificate-dialog.html',
                    controller: 'MemberManagementDeleteCertificateController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member-management-detail', null, { reload: 'member-management-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('member-management-detail.new-dept', {
            parent: 'member-management-detail',
            url: '/dept/new',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('dept');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: entity,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.dept', {select: $stateParams.id});
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
